import { SampleResultStatus } from '../../utils/sampleUtils'
import {
  HourglassMediumIcon,
  Mtds,
  ThumbsDownIcon,
  ThumbsUpIcon,
  WarningIcon
} from 'prove-common'

const STATUS_COLOR = {
  [SampleResultStatus?.negative]: 'success',
  [SampleResultStatus?.positive]: 'danger',
  [SampleResultStatus?.inconclusive]: 'warning',
  [SampleResultStatus?.cancelled]: 'warning'
} as const

const STATUS_ICON = {
  [SampleResultStatus?.negative]: <ThumbsUpIcon />,
  [SampleResultStatus?.positive]: <ThumbsDownIcon />,
  [SampleResultStatus?.inconclusive]: <WarningIcon />,
  [SampleResultStatus?.cancelled]: <WarningIcon />
}

type SampleResultTagProps = {
  status: SampleResultStatus
  className?: string
}

export const SampleResultTag = ({
  status,
  className
}: SampleResultTagProps) => (
  <Mtds.Tag
    className={className}
    data-color={STATUS_COLOR[status] || 'neutral'}
    data-icon='none'
  >
    {STATUS_ICON[status] || <HourglassMediumIcon />}
    {status}
  </Mtds.Tag>
)
